export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/winner-7d2c81783f98d3243d8f6796f8a1dd43.mp3";